// import fetch from '../utils/fetch';
import fetch,{postFrom} from '../utils/fetch';

// 物品档案添加下拉框数据获取
export function getSelectedData() {
    return fetch({
        method: 'GET',
        url: 'archives/condition'
    })
}

// 物品档案状态
export function getGoodsUseStatus() {
    return fetch({
        method: 'GET',
        url: 'archives/getGoodsUseStatus'
    })
}

// 获取物品档案列表

export function getGoodsList(params) {
    return fetch({
        method: 'GET',
        url: 'archives/list',
        params
    })
}

// 添加物品档案
export function addArchives(data) {
  return fetch({
      method: 'POST',
      url: 'archives/add',
      data
  })
}

// 查看物品档案
export function readGoodsArchives(params) {
    return fetch({
        method: 'GET',
        url: 'archives/detail',
        params
    })
}

// 修改物品档案
export function updateArchives(data) {
    return fetch({
        method: 'POST',
        url: 'archives/update',
        data
    })
  }

// 检查物品档案编码是否存在
export function checkCode(params) {
    return fetch({
        method: 'GET',
        url: 'archives/checkCode',
        params
    })
}

// 下载模版
export function downloadTemplate() {
    return fetch({
        method: 'GET',
        url: 'archives/template/download'
    })
}

// 转入物品
export function transferGoodsIn(data) {
    return fetch({
        method: 'POST',
        url: 'archives/transferGoodsIn',
        data
    })
  }

// 删除物品
export function deleteGoods(data) {
    return postFrom('archives/delete',data)
}

// 物品状态变更

export function updateGoodsStatus(data) {
    return fetch({
        method: 'POST',
        url: 'archives/updateGoodsStatus',
        data
    })
  }

  // 物品损坏赔偿关联合同
  export function getContract(params){
    return fetch({
        method: 'GET',
        url: 'contract/roomOwn',
        params
    })
}